import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propFunc, propId, propStr, } from '../../../../../../../helpers/custom-prop-types';
import DirectoryCheckIcon from '../../../../../../Icon/Svg/DirectoryCheckIcon';
import DirectoryPlusIcon from '../../../../../../Icon/Svg/DirectoryPlusIcon';
const ReceivedButton = (props) => {
    const { className, id, onClick, receivedAt } = props;
    return (_jsx("div", Object.assign({ className: clsx('proffit_search_folder_received_button', className) }, { children: receivedAt ? (_jsxs("div", Object.assign({ className: 'button_inner' }, { children: [_jsx(DirectoryCheckIcon, { className: 'button_icon' }), _jsx("span", { children: "\u30B9\u30E9\u30A4\u30C9\u53D7\u9818\u6E08\u307F" })] }))) : (_jsxs("button", Object.assign({ className: 'button_inner', onClick: onClick, type: 'button', value: id }, { children: [_jsx(DirectoryPlusIcon, { className: 'button_icon' }), _jsx("span", { children: "\u30B9\u30E9\u30A4\u30C9\u3092\u53D7\u9818\u3059\u308B" })] }))) })));
};
ReceivedButton.propTypes = {
    className: propStr(),
    id: propId().isRequired,
    onClick: propFunc().isRequired,
    receivedAt: propStr(),
};
ReceivedButton.defaultProps = {
    className: '',
    receivedAt: null,
};
export default ReceivedButton;
